<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-0 mt-4 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
      :locale="{ emptyText: emptyTemplate }"
    >
      <div
        slot="codigo_queja"
        class="title-size font-bold text-gray-500 text-center"
      >
        Código de queja
      </div>
      <div
        slot="nombres"
        class="title-size font-bold text-gray-500 text-center"
      >
        Nombre del CF
      </div>
      <div
        slot="company_emisores_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Entidad
      </div>
      <div
        slot="motivo_emisores_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Motivo
      </div>

      <!-- Custom rendering for estado_solip_name column -->
      <template slot="estado_solip_name" slot-scope="text, record">
        <ComplaintEmisorStatusLabel :status="record.estado_solip_name" />
      </template>

      <div
        slot="estado_solip_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado de radicación
      </div>

      <!-- Custom rendering for estado_solip_anexes_name column -->
      <template slot="estado_solip_anexes_name" slot-scope="text, record">
        <ComplaintEmisorStatusLabel :status="record.estado_solip_anexes_name" />
      </template>

      <div
        slot="estado_solip_anexes_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado de radicación de anexos
      </div>

      <div slot="fecha_creacion" class="title-size font-bold text-gray-500">
        Fecha de radicación
      </div>

      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div
        slot="actions"
        slot-scope="text, record"
        class="flex flex-row justify-items-center"
      >
        <!--retry-->
        <button
          v-if="record.estado_solip_name == 'Error en radicación'"
          class="flex justify-center text-xs mx-auto text-blue h-min"
          @click="retryRadicadoSolip(record.codigo_queja)"
        >
          <a-icon
            type="reload"
            :style="{ fontSize: '19px', color: '#3366cc' }"
          />
        </button>
        <!--blue eye-->
        <button
        @click="solicitudeDetail(record.id)"          
          v-if="             
            (record.estado_solip_name == 'Radicada' &&
              record.estado_solip_anexes_name == 'Radicada') ||
            (!record.estado_solip_name && !record.estado_solip_anexes_name) ||
            record.estado_solip_name == 'Servicio deshabilitado'
          "
          class="flex justify-center text-xs mx-auto text-blue h-min"
        >
          <a-icon type="eye" :style="{ fontSize: '19px', color: '#3366cc' }" />
        </button>
        <!--red eye-->
        <button
          @click="solicitudeDetail(record.id)" 
          v-if="
            record.estado_solip_name == 'Error en radicación' ||
            record.estado_solip_anexes_name == 'Error en radicación de anexo(s)'
          "
          class="flex justify-center text-xs mx-auto text-blue h-min"
        >
          <a-icon type="eye" :style="{ fontSize: '19px', color: '#e02424' }" />
        </button>
      </div>
    </a-table>
  </div>
</template>

<script>
import ComplaintEmisorStatusLabel from "../partials/ComplaintEmisorStatusLabel.vue";
const columns = [
  {
    slots: { title: "codigo_queja" },
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    width: 100,
  },
  {
    slots: { title: "nombres" },
    dataIndex: "nombres",
    key: "nombres",
    width: 100,
  },
  {
    slots: { title: "company_emisores_name" },
    dataIndex: "company_emisores_name",
    key: "company_emisores_name",
    width: 110,
  },
  {
    slots: { title: "motivo_emisores_name" },
    dataIndex: "motivo_emisores_name",
    key: "motivo_emisores_name",
    width: 180,
  },
  {
    slots: { title: "estado_solip_name" },
    dataIndex: "estado_solip_name",
    key: "estado_solip_name",
    scopedSlots: { customRender: "estado_solip_name" }, // Enable custom rendering
    width: 110,
  },
  {
    slots: { title: "estado_solip_anexes_name" },
    dataIndex: "estado_solip_anexes_name",
    key: "estado_solip_anexes_name",
    scopedSlots: { customRender: "estado_solip_anexes_name" }, // Enable custom rendering
    width: 130,
  },
  {
    slots: { title: "fecha_creacion" },
    dataIndex: "fecha_creacion",
    key: "fecha_creacion",
    width: 100,
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 75,
  },
];

export default {
  components: {
    ComplaintEmisorStatusLabel,
  },
  props: ["dataSource"],
  data() {
    return {
      columns,
      emptyTemplate: (
        <div style="text-align: center; padding: 20px;">
          <a-icon type="inbox" style="font-size: 48px; " />
          <p
            style="margin-top: 8px; font-size: 18px;"
            class="text-gray-500 font-bold"
          >
            No se encontraron resultados
          </p>
        </div>
      ),
    };
  },
  methods: {
    retryRadicadoSolip(codigoQueja) {
      this.$emit("retryRadicadoSolip", codigoQueja); 
    },
    async solicitudeDetail(checked, record) {
      this.$router.push({
        name: "soliditude-detail",
        params: { id: record.document_id },
      });
    },
    solicitudeDetail(id) {       
       this.$router.push(`/dashboard/complaints-emisor/detail/${id}`);           
    },
  },
};
</script>
